exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vtl-icon-edit {\n    display: none;\n}\n.vs__selected-options {\n    flex-wrap: nowrap;\n}\n.icon:hover {\n    cursor: pointer;\n}\n", ""]);

// exports
